<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Reporte Prefondeo Corresponsales</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-lg-block">
                <b-button variant="default" pill block size="sm" title="Agregar" v-b-modal.add>
                    <i class="material-icons mdi mdi-cash-plus"></i>&nbsp;
                    <span>Agregar Fondos</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(amount_text)="row">
                        <template v-if="row.item.amount >= 0">
                            <b class="text-success">{{ row.item.amount_text }}</b>
                        </template>
                        <template v-else>
                            <b class="text-danger">{{ row.item.amount_text }}</b>
                        </template>
                    </template>

                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" :to="'/admin/reports/payers/balance/'+row.item.payer">
                            <i class="material-icons">wallet</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Add Founds -->
                <b-modal
                    id="add"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    title="Agregar Fondos"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formData" @submit.stop.prevent="addFounds()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.payer+':'">
                                    <b-form-select
                                        name="payer"
                                        :options="payers"
                                        :value="form.payer"
                                        v-model="form.payer"
                                        class="form-control text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('payer')"
                                        :data-vv-as="(labels.payer).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="payer-live-feedback"
                                        value-field="payer"
                                        text-field="payer"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="payer-live-feedback">
                                        {{ veeErrors.first('payer') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.amount+':'">
                                    <b-form-input
                                        name="amount"
                                        v-model="form.amount"
                                        type="number"
                                        inputmode="numeric"
                                        step="0.01"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('amount')"
                                        :data-vv-as="(labels.amount).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="amount-live-feedback"/>
                                    <b-form-invalid-feedback id="amount-live-feedback">
                                        {{ veeErrors.first('amount') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.text+':'">
                                    <b-form-textarea
                                        id="text"
                                        name="text"
                                        v-model="form.text"
                                        v-validate="'max:255|required:true'"
                                        :state="validateState('text')"
                                        aria-describedby="text-live-feedback"
                                        :data-vv-as="(labels.text).toLowerCase()"
                                        placeholder="Descripción..."
                                        rows="3"
                                        no-resize
                                        :disabled="loading"
                                        class="rounded"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback id="text-live-feedback">
                                        {{ veeErrors.first('text') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5"
                                          form="formData" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="cash-coin" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Agregando...' : 'Agregar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import axios from "axios";

export default {
    name: "ReportPayersBalance",
    props: [ 'user' ],
    data: () => ({
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'payer', label: 'Corresponsal', sortable: true },
            { key: 'amount_text', label: 'Valor', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency', label: 'Moneda', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        labels: {
            payer: 'Corresponsal',
            text: 'Descripción',
            amount: 'Valor'
        },
        form: {
            payer: 'JETPERU',
            text: null,
            type: '+',
            amount: null,
            currency: 'USD'
        },
        payers: [
            { payer: 'JETPERU' },
            { payer: 'OMNEX' },
            { payer: 'TERRAPAY' },
            { payer: 'REMITEE' }
        ]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'payersbalancepage');
        this.totalRows = this.items.length;
        this.getData();
    },
    methods: {
        getData() {
            axios.get('/api/admin/reports/payers/balance').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getData, 180000);
        },
        addFounds() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/admin/reports/payers/balance/' + this.form.payer + '/add', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.$bvModal.hide('add');
                    this.loading = false;
                });
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
